export default __webpack_public_path__ + "static/media/QK_9274.fac63d45.jpg";